import { z } from "zod";

export const bookAppointmentSchema = z.object({
  patientId: z.number().min(1, { message: "Patient id is required" }),
  appointmentExists: z.boolean().optional(),
  appointmentType: z.string().min(1, { message: "Appointment type is required" }),
  appointmentDetails: z.object({
    appointmentDate: z.date({ required_error: "Appointment date is required" }),
    startTime: z.date({ required_error: "Start time is required" }),
    endTime: z.date({ required_error: "End time is required" }),
    doctorName: z.string().min(1, { message: "Doctor name is required" }),
    professionalId: z.string().min(1, { message: "Unique code is required" }),
    branchId: z.number().min(1, { message: "Branch Id is required" }),
    fee: z.string().optional().nullable(),
  }),
  symptoms: z.array(z.string()),
  healthRecords: z.array(
    z.object({
      doctorNameOrLabName: z.string().optional(),
      uploadRecords: z.array(
        z.object({
          reportData: z.string().min(1, { message: "Report data is required" }),
          reportName: z.string().min(1, { message: "Report name is required" }),
        }),
      ),
    }),
  ),
});

export type BookAppointmentSchema = z.infer<typeof bookAppointmentSchema>;
